<template>
  <v-card class="elevation-8 pt-10 pb-10 pl-5 pr-5" height="500px">
    <v-img height="90" contain src="@/assets/logo.png"> </v-img>
    <v-card-title class="font-weight-black justify-center">
      {{ form_title }}
    </v-card-title>
    <v-card-subtitle class="font-weight-black text-center mt-0"> 系統登入 </v-card-subtitle>

    <v-card-text style="padding: 0 0 0">
      <v-text-field
        v-model="account"
        prepend-icon="mdi-email"
        name="login"
        :label="account_label_text"
        type="text"
        @keyup.enter="signIn"
      ></v-text-field>
      <v-text-field
        id="password"
        v-model="password"
        prepend-icon="mdi-lock"
        name="password"
        :label="password_label_text"
        type="password"
        @keyup.enter="signIn"
      ></v-text-field>
      <span class="grey--text lighten-3 clickable forget-hover d-flex justify-end mb-3" @click="goForgetPwd">
        忘記密碼?
      </span>
    </v-card-text>
    <!-- <div class="d-flex justify-center mb-3">
			還沒有帳號？
			<span
				class="red--text lighten-3 clickable forget-hover"
				@click="goRegister"
			>
				立即註冊
			</span>
		</div> -->
    <v-card-actions class="justify-center">
      <v-btn outlined color="#ee5e58" class="pl-10 pr-10" @click="signIn">
        {{ form_action_btn_text }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
import { mapGetters } from 'vuex'
import { apiLogin, apiUpdateDefult } from '@/api/user.js'
import { apiGetContainers } from '@/api/optimize.js'

export default {
  name: 'SignIn',
  components: {},
  computed: {
    ...mapGetters(['loggedInfo']),
  },
  created: function () {
    this.initPage()
  },
  mounted: function () {
    console.log(process.env.VUE_APP_MODE)
    console.log(process.env.VUE_APP_API_ENDPOINT)
    this.$store.commit('resetState')
  },
  data: function () {
    return {
      // 登入視窗標題
      form_title: '',

      // 登入視窗副標題
      form_subtitle: '',

      // 帳號的數值
      account: '',

      // 帳號輸入框的標題文字
      account_label_text: '',

      // 密碼的數值
      password: '',

      // 密碼輸入框的標題文字
      password_label_text: '',

      // 登入按鈕的文字
      form_action_btn_text: '',
    }
  },
  methods: {
    /**
     * 2022/1/2 created by Watson
     *
     * function description:
     * 初始化頁面參數
     *
     * @return {none}
     */
    initPage: function () {
      this.form_title = 'Optimize99'
      this.form_subtitle = ''
      this.account = ''
      this.account_label_text = '信箱'
      this.password = ''
      this.password_label_text = '密碼'
      this.form_action_btn_text = '登入'
    },
    /**
     * 2022/1/2 created by Watson
     *
     * function description:
     * 登入功能
     *
     * @return {none}
     */
    signIn: async function () {
      // console.log('isLogin',this.$store.state.isLogged)
      // this.$store.commit('login')
      // console.log('isLogin',this.$store.state.isLogged)
      // this.$router.push('/organization')

      if (!this.account) {
        this.$root.vtoast.show({
          message: '請輸入帳號',
        })

        return
      }

      if (!this.password) {
        this.$root.vtoast.show({
          message: '請輸入密碼',
        })
        return
      }

      console.log('帳號:', this.account)
      console.log('密碼:', this.password)
      let that = this
      let result = await apiLogin({
        email: this.account,
        password: this.password,
      })
        .then(function (resp) {
          let data = resp.data
          console.log(data)

          if (data.data.organizations.length === 0) {
            that.$root.vtoast.show({
              message: '此帳號無所屬組織',
            })
            return null
          }

          that.$root.vtoast.show({
            message: '登入成功！',
          })

          localStorage.setItem('authorization_token', data.data.token)
          console.log(that.$store)

          // 先取第一個組織的第一個容器
          // 如果沒有的話，就到組織頁就好
          console.log('login', data.data)

          // let { organizations } = data.data
          // let [ first ] = organizations;
          // that.updateDefult(first)

          return data.data
          // that.$router.push('/:container_id/home')
          // that.$store.commit('login', data.data)
          // console.log(data.data.organizations[0])
          // that.$store.commit('select_organize', data.data.organizations[0])
        })
        .catch(function (error) {
          console.log(error)

          if (!error.response) {
            that.$root.vtoast.show({
              message: '登入失敗，原因: ' + error,
            })
          } else {
            that.$root.vtoast.show({ message: '帳號密碼輸入錯誤' })
          }

          return null
        })

      if (result === null) {
        return
      }

      console.log('result', result)
      that.$store.commit('login', result)
      let user_info_container = []
      if (result.container_user_enabled.container) {
        result.container_user_enabled.container.forEach((container) => {
          user_info_container.push(container.id)
        })
      }

      let account_organizations = result.organizations
      // console.log('account_organizations', account_organizations)
      // 取所有org對應的container
      let organize_container_mapper = {}

      for (let idx = 0; idx < account_organizations.length; idx++) {
        let account_organization = account_organizations[idx]
        // console.log('account_organization', account_organization)
        let containers = await apiGetContainers(account_organization.org_id)
          .then(function (resp) {
            let data = resp.data.data
            console.log('containers', data)
            return data
          })
          .catch(function (error) {
            console.log('取得容器失敗，原因: ' + error)
            // that.$root.vtoast.show({ message: "取得組織容器失敗，原因: " + (error.response ? error.response.data : error) })
            return []
          })
        // beta user什麼都看得到
        if (!result.is_beta_user) {
          // 如果有找到，代表有限制過可看到的容器，沒有找到預設就是全開
          let is_container_user = result.container_user_enabled.enabled_status.find((enabled_status) => {
            return enabled_status.userAuthId.orgId === account_organization.org_id && enabled_status.enable
          })
          console.log('is_container_user', is_container_user)
          if (is_container_user) {
            containers = containers.filter((container) => {
              return user_info_container.includes(container.id)
            })
          }
        }
        console.log('filter_container', containers)
        organize_container_mapper[account_organization.org_id] = {
          organization: account_organization,
          containers: containers,
        }
      }

      if (Object.keys(organize_container_mapper).length === 0) {
        that.$root.vtoast.show({
          message: '您的帳號無所屬任何組織，請先加入組織',
        })
        return
      }

      this.$store.commit('update_organize_container_mapper', organize_container_mapper)
      console.log(organize_container_mapper)

      let to_org_id = ''
      if (result.default_value) {
        if (result.default_value.last_seen_org && organize_container_mapper[result.default_value.last_seen_org]) {
          to_org_id = result.default_value.last_seen_org
        }
      } else {
        to_org_id = Object.keys(organize_container_mapper)[0]
      }

      let to_container_id = ''
      let match_container = []
      if (result.default_value && result.default_value.last_seen_container_id) {
        match_container = organize_container_mapper[to_org_id].containers.filter(function (container) {
          return container.id === result.default_value.last_seen_container_id
        })

        if (match_container.length !== 0) {
          to_container_id = match_container[0].id
        } else {
          if (organize_container_mapper[to_org_id].containers[0]) {
            to_container_id = organize_container_mapper[to_org_id].containers[0].id
          }
        }
      } else {
        if (organize_container_mapper[to_org_id].containers[0]) {
          to_container_id = organize_container_mapper[to_org_id].containers[0].id
        }
      }

      this.$store.commit('select_organize', organize_container_mapper[to_org_id].organization)
      if (to_container_id) {
        this.$store.commit('selected_container', match_container[0])
      }

      if (to_container_id) {
        const query = new URLSearchParams(this.$route.query)
        if (query.has('line-group-token')) {
          this.$router.push(`/${to_org_id}/${to_container_id}/home?${query}`)
        } else {
          this.$router.push(`/${to_org_id}/${to_container_id}/home`)
        }
      } else {
        this.$router.push(`/${to_org_id}/home`)
      }
    },
    goForgetPwd: function () {
      this.$router.push('/forget_password')
    },
    updateDefult(first_org) {
      // 預設將第一個組織直接設定為預設組織
      console.log(first_org)
      let param = {
        default_value: {
          organization: first_org['org_name'],
        },
      }
      apiUpdateDefult(param)
        .then((resp) => {
          let { data } = resp
          console.log('預設成功 : ', data)
        })
        .catch((error) => {
          console.log(error)
        })
    },
    // goRegister() {
    // 	this.$router.push('/register')
    // }
  },
}
</script>
<style scoped>
.clickable {
  cursor: pointer;
}
</style>
